import React from 'react'
import SimpleCard from 'components/SimpleCard'
import { Col, Row } from 'reactstrap'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import CustomSelect from 'components/Select'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { CREDENCIAIS } from 'store/modules/backoffice/credenciais/types'
import * as credenciaisActions from 'store/modules/backoffice/credenciais/actions'
import useRedux from 'hooks/useRedux'

const Itau = () => {
  const { usuariosInstituicaoItau, itau } = useSelector<
    ApplicationState,
    CREDENCIAIS
  >((state) => state.credenciais)
  const { dispatch } = useRedux()

  type LoginFields = keyof CREDENCIAIS['itau']
  function onChange(value: string, field: LoginFields) {
    dispatch(credenciaisActions.setLoginItau(value, field))
  }
  return (
    <SimpleCard>
      <SimpleTitleCard>Usuário consig Itaú </SimpleTitleCard>
      <Row className="d-flex flex-column align-items-center row-gap-15">
        <Col md={8}>
          <label className="label-12">Usuário</label>
          <CustomSelect
            options={usuariosInstituicaoItau}
            placeholder="Selecione o usuário"
            onChange={(e) => onChange(e, 'usuario')}
            value={itau.usuario}
            accessorLabel="usuarioInstituicao"
            accessorValue="usuarioInstituicao"
            isSearchable={false}
          />
        </Col>
        <Col md={4} className="d-flex justify-content-center">
          <CustomButton
            background="#662d90"
            onClick={() => {
              dispatch(
                credenciaisActions.salvarCredenciaisItauSaga({
                  usuario: itau.usuario
                })
              )
              dispatch(credenciaisActions.cleanLoginItau())
            }}
          >
            Salvar
          </CustomButton>
        </Col>
      </Row>
    </SimpleCard>
  )
}

export default Itau
